@if (errors().length > 0) {
  <div class="field-error">
    @for (error of errors(); track error) {
      <span class="field-error__text">{{ error }}</span>
    }
  </div>
}
